/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import UInt64DTO from './UInt64DTO';





/**
* The TransactionStatusDTO model module.
* @module model/TransactionStatusDTO
* @version 0.7.15
*/
export default class TransactionStatusDTO {
    /**
    * Constructs a new <code>TransactionStatusDTO</code>.
    * @alias module:model/TransactionStatusDTO
    * @class
    * @param status {String} 
    */

    constructor(status) {
        

        
        

        this['status'] = status;

        
    }

    /**
    * Constructs a <code>TransactionStatusDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/TransactionStatusDTO} obj Optional instance to populate.
    * @return {module:model/TransactionStatusDTO} The populated <code>TransactionStatusDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TransactionStatusDTO();

            
            
            

            if (data.hasOwnProperty('group')) {
                obj['group'] = ApiClient.convertToType(data['group'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('hash')) {
                obj['hash'] = ApiClient.convertToType(data['hash'], 'String');
            }
            if (data.hasOwnProperty('deadline')) {
                obj['deadline'] = UInt64DTO.constructFromObject(data['deadline']);
            }
            if (data.hasOwnProperty('height')) {
                obj['height'] = UInt64DTO.constructFromObject(data['height']);
            }
        }
        return obj;
    }

    /**
    * @member {String} group
    */
    group = undefined;
    /**
    * @member {String} status
    */
    status = undefined;
    /**
    * @member {String} hash
    */
    hash = undefined;
    /**
    * @member {module:model/UInt64DTO} deadline
    */
    deadline = undefined;
    /**
    * @member {module:model/UInt64DTO} height
    */
    height = undefined;








}


